export const apiKeyTypes = {
    acmeware: 'Acmeware Api Client'
};